import React from 'react';

import { Chip, Stack, Tab, Tabs } from '@mui/material';

export const INVENTORY_SUB_TABS = [
  'Inventory',
  'Surcharges',
  'Blackouts',
  'Capacity',
  'Included guests',
  'Extra guest surcharge',
  'Lead days',
  'Lengths of stay',
  'Revenue management',
] as const;

export type InventorySubTab = (typeof INVENTORY_SUB_TABS)[number];

interface Props {
  value: InventorySubTab;
  onChange: (value: InventorySubTab) => void;
  tabCounts?: Partial<Record<InventorySubTab, number>>;
}

function getTabLabel(tab: InventorySubTab, count: number | undefined) {
  if (count === undefined) {
    return tab;
  }

  return (
    <Stack direction="row" alignItems="center" spacing={0.75}>
      <span>{tab}</span>
      <Chip label={count} size="small" sx={{ height: 18, fontSize: 11, '& .MuiChip-label': { px: 0.75 } }} />
    </Stack>
  );
}

export default function InventorySubTabs({ value, onChange, tabCounts }: Props) {
  return (
    <Tabs
      value={value}
      variant="scrollable"
      scrollButtons="auto"
      sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
      onChange={(_event, nextValue: InventorySubTab) => onChange(nextValue)}
    >
      {INVENTORY_SUB_TABS.map((tab) => (
        <Tab key={tab} value={tab} label={getTabLabel(tab, tabCounts?.[tab])} />
      ))}
    </Tabs>
  );
}
